<template>
  <div>
    <v-btn
      class="hidden-sm-and-down"
      color="primary"
      rounded
      small
      @click="open()"
      >New User</v-btn
    >
    <v-btn
      class="hidden-sm-and-up primary"
      small
      icon
      color="primary"
      @click="open()"
    >
      <v-icon small color="white"> mdi-plus </v-icon>
    </v-btn>
    <v-navigation-drawer
      app
      temporary
      right
      disable-resize-watcher
      width="650px"
      v-model="show"
      class="actionDrawer"
    >
      <v-card flat>
        <v-card-text class="pt-0">
          <v-row class="mx-4 mt-4" justify="center" align="center">
            <v-col cols="2">
              <v-btn @click="cancelOperation()" color="primary" icon>
                <v-icon>mdi-arrow-left-bold-circle</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="8" class="text-center">
              <v-img
                :src="this.$store.state.agency.agencyLogo"
                width="280px"
                class="mx-auto"
              />
            </v-col>
            <v-col cols="2"> </v-col>
          </v-row>
          <v-row class="mx-4">
            <v-col cols="12">
              <v-form ref="form" v-model="valid">
                <v-row>
                  <v-col cols="12" class="text-center">
                    <h1 class="danetest--text">New User Details</h1>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" class="pb-0">
                    <v-text-field
                      v-model="firstName"
                      label="First Name"
                      class="input"
                      :rules="textRules"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" class="pb-0">
                    <v-text-field
                      v-model="lastName"
                      label="Last Name"
                      class="input"
                      :rules="textRules"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-text-field
                      v-model="mobile"
                      label="Mobile"
                      class="input"
                      :rules="textRules"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" class="pt-0">
                    <v-text-field
                      v-model="email"
                      label="Email Address"
                      class="input"
                      :rules="emailRules"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-select
                      v-model="userType"
                      :items="userTypes"
                      item-text="name"
                      item-value="value"
                      label="User Type"
                      class="my-0 pt-0"
                      :rules="textRules"
                    ></v-select>
                  </v-col>
                  <v-col
                    v-if="
                      (this.$store.state.user.userType == 'SA' &&
                        userType == 'AA') ||
                      (this.$store.state.user.userType == 'SA' &&
                        userType == 'SMM') ||
                      (this.$store.state.user.userType == 'SA' &&
                        userType == 'SB') ||
                      (this.$store.state.user.userType == 'SA' &&
                        userType == 'RS')
                    "
                    cols="12"
                    class="py-0"
                  >
                    <v-select
                      v-model="agency"
                      :items="agencies"
                      item-text="agencyName"
                      item-value="agencyId"
                      label="Select Agency"
                      class="my-0 pt-0"
                    ></v-select>
                  </v-col>
                  <v-col cols="6" class="text-center">
                    <v-btn
                      small
                      rounded
                      @click="cancelOperation()"
                      class="compeatsecondary white--text"
                    >
                      Cancel
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="text-center">
                    <v-btn
                      :disabled="!valid"
                      small
                      class="primary white--text"
                      :loading="loading"
                      rounded
                      @click="createDashboardUser()"
                      >Add User</v-btn
                    >
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="130">
          <p class="mb-0 overlaytext">Please Wait...</p>
        </v-progress-circular>
      </v-overlay>
      <!-- <v-overlay :absolute="absolute" :value="overlay">
        <v-card class="secondary px-4 py-4">
          <v-row>
            <v-col class="col-12 black--text text-center">
              <v-icon size="50" color="primary">mdi-alert-circle</v-icon>
              <p class="body-1 py-3">
                Opps something went wrong, please try again.
              </p>
              <v-btn icon color="primary" @click="cancelError()">
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-overlay> -->
    </v-navigation-drawer>
  </div>
  <!-- </template>
    </v-dialog> -->
</template>

<script>
import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "../../firebaseConfig";
export default {
  props: ["successAlert", "agencies"],

  data: () => ({
    show1: false,
    overlay: false,
    absolute: true,
    show: false,
    dialog: false,
    successResponse: "",
    errorMessage: false,
    loading: false,
    agencyName: "",
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    password: "",
    userType: "",
    agency: "",
    valid: false,
    textRules: [(v) => !!v || "Field is required"],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    userTypes: [],
    agencyList: [
      { name: "Agency Admin", value: "AA" },
      { name: "Social Marketing Manager", value: "SMM" },
      { name: "Subscriber", value: "SB" },
      { name: "Agency Sales", value: "AS" },
    ],
    superAdminList: [
      { name: "Agency Admin", value: "AA" },
      { name: "Social Marketing Manager", value: "SMM" },
      { name: "Subscriber", value: "SB" },
      { name: "Super Admin", value: "SA" },
      { name: "Reseller", value: "RS" },
    ],
  }),
  created() {
    // this.userTypes = [];
    if (
      this.$store.state.user.userType == "AA" ||
      this.$store.state.user.userType == "SMM"
    ) {
      this.userTypes = this.agencyList;
    } else if (this.$store.state.user.userType == "SA") {
      this.userTypes = this.superAdminList;
    }
  },
  methods: {
    validate() {
      this.$refs.form.validate();
    },
    //Generate password for new Subscriber
    generateRandomPassword() {
      const length = 12;
      const charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let newPassword = "";

      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        newPassword += charset.charAt(randomIndex);
      }

      this.password = newPassword;
      return this.password;
    },
    async createDashboardUser() {
      this.overlay = true;

      if (
        this.$store.state.user.userType == "AA" ||
        this.$store.state.user.userType == "SMM"
      ) {
        this.agency = this.$store.state.user.agencyId;
      }

      try {
        const functions = getFunctions(firebaseApp, "europe-west2");
        const createUser = httpsCallable(functions, "createUser");

        createUser({
          name: this.firstName + " " + this.lastName,
          email: this.email,
          password: this.generateRandomPassword(),
          mobile: this.mobile,
          userType: this.userType,
          agency: this.agency,
        })
          .then((result) => {
            let res = result.data.result;
            this.emailAdminUser();
          })
          .catch((error) => {
            this.overlay = false;
            const errorMessage = error.message;
            this.alert = true;
            this.alertType = "error";
            this.successResponse =
              "Opps something went wrong " + errorMessage + "!";
            this.loading = false;
            setTimeout(() => {
              this.alert = false;
            }, 5000);
          });
      } catch (err) {
        console.log(err);
      }
    },
    //email logins
    async emailAdminUser() {
      try {
        const functions = getFunctions(firebaseApp, "europe-west2");
        const emailAdminUserLogins = httpsCallable(
          functions,
          "emailAdminUserLogins"
        );

        emailAdminUserLogins({
          name: this.firstName + " " + this.lastName,
          email: this.email,
          password: this.password,
          mobile: this.mobile,
          userType: this.userType,
          agency: this.agency,
        })
          .then((result) => {
            let res = result.data.result;
            this.overlay = false;
            this.alert = true;
            this.alertType = "success";
            this.successResponse = "Successfully Added New User.";
            this.$emit("successAlert", this.successResponse, this.alertType);
            this.cancelOperation();
          })
          .catch((error) => {
            this.overlay = false;
            const errorMessage = error.message;
            this.alert = true;
            this.alertType = "error";
            this.successResponse =
              "Opps something went wrong " + errorMessage + "!";
            this.loading = false;
            setTimeout(() => {
              this.alert = false;
            }, 5000);
          });
      } catch (err) {
        console.log(err);
      }
    },

    cancelError() {
      this.overlay = false;
    },

    cancelOperation() {
      this.$refs.form.reset();
      this.show = false;
    },
    open() {
      this.show = !this.show;
    },
  },
};
</script>

<style>
h6 {
  font-size: 30px;
}
</style>
